function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { Form, Input, Button, DatePicker, Select, Modal, Alert, Switch } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import { CheckSquareFill } from 'react-bootstrap-icons';
import Common from '../includes/Common';
import moment from 'moment';
import dayjs from 'dayjs';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditTask = function EditTask(_ref) {
  var task = _ref.task,
    handler = _ref.handler;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    userOptions = _useState2[0],
    setUserOptions = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    taskRemind = _useState4[0],
    setTaskRemind = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormLoading = _useState6[0],
    setIsFormLoading = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    formError = _useState8[0],
    setFormError = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedUserOptions = _useState0[0],
    setSelectedUserOptions = _useState0[1];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + "edittask", {
      id: task.id,
      label: values.label,
      users: values.users,
      type: values.type,
      planned_date: values.planned_date,
      description: values.description,
      remind: taskRemind
    }).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onRemindChange = function onRemindChange(checked) {
    setTaskRemind(checked);
  };
  useEffect(function () {
    var su = new Array();
    task.users.forEach(function (u) {
      su.push(u.user_id);
    });
    form.setFieldsValue({
      description: task.description,
      users: su,
      remind_date: values.remind_date,
      label: task.label,
      type: task.type,
      planned_date: dayjs(task.planned_date)
    });
    axios.get(Common.baseApiUrl + 'getplatformusers/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUserOptions([]);
        response.data.users.forEach(function (u) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: u.id,
              label: "".concat(u.prenom, " ").concat(u.nom, " - ").concat(u.job)
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 6 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          banner: true,
          message: formError
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Tache",
        name: "label",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "type",
        label: "Type",
        rules: [{
          required: true,
          message: "Champ obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: [{
            value: 0,
            label: "Tache"
          }, {
            value: 1,
            label: "Evenement"
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Description",
        name: "description",
        children: /*#__PURE__*/_jsx(TextArea, {
          showCount: true,
          maxLength: 100,
          placeholder: "Entrer une description"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "planned_date",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(DatePicker, {
          showTime: true,
          format: "DD-MM-YYYY HH:mm",
          placeholder: "Date limite"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "users",
        label: "Assign\xE9e \xE0",
        children: /*#__PURE__*/_jsx(Select, {
          mode: "multiple",
          options: userOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Activer le rappel",
        children: /*#__PURE__*/_jsx(Switch, {
          defaultChecked: taskRemind == 1,
          onChange: onRemindChange
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Date de rappel",
        name: "remind_date",
        rules: [{
          required: taskRemind == 1,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(DatePicker, {
          disabled: taskRemind == 0,
          showTime: true,
          placeholder: "Chosir la date de rappel"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          type: "primary",
          htmlType: "submit",
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(CheckSquareFill, {
              size: 20
            }), " METTRE A JOUR"]
          })
        })
      })]
    })
  });
};
export default EditTask;